import { t } from '@lingui/core/macro'
import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import { Link } from 'react-router-dom'
import type { ExtendedBusinessUser } from '../BizApi'
import SvgEdit from '@jotta/ui/SvgEdit'

export function BizActionButtonEditUser({
  user,
  className,
}: {
  user: Pick<ExtendedBusinessUser, 'username' | 'name'>
  className?: string
}) {
  return (
    <Link
      to={`${user.username}`}
      className={className}
      title={`${t`Modify user`} ${user.name}`}
    >
      <PlainBrandIcon icon={SvgEdit} />
    </Link>
  )
}
